// import { folderFragment } from "./JournalFragments";
import { gql } from "lib/apolloClient";

import { folderFragments } from "./JournalFragments";
export const getCourseFolders = gql`
  query getCourseFoldersQuery($courseId: ID!, $filters: PostFilterInput) {
    node(id: $courseId, type: COURSE) {
      id
      ... on Course {
        id
        folders {
          ...folderItemWithFilters
        }
      }
    }
  }
  ${folderFragments.folderItemWithFilters}
`;

export const getCourseFoldersDetailsQuery = gql`
  query getCourseFoldersQuery($courseId: ID!) {
    node(id: $courseId, type: COURSE) {
      id
      ... on Course {
        id
        folders {
          ...folderDetails
        }
      }
    }
  }
  ${folderFragments.folderDetails}
`;

export const getTaggedPostStudentFolders = gql`
  query getTaggedPostStudentFolders(
    $studentIds: [ID!]
    $courseId: ID!
    $filters: PostFilterInput
  ) {
    node(id: $courseId, type: COURSE) {
      ... on Course {
        id
        taggedPostStudentFolders(studentIds: $studentIds) {
          student {
            id
          }
          folders {
            ...folderItemWithFilters
          }
        }
      }
    }
  }
  ${folderFragments.folderItemWithFilters}
`;
